import React from 'react';

import {
  Form,
  InputField,
  ListItem,
  Modal,
} from 'vindi-ds-components';

import templates from '../templates.json';

const { paymentMethods } = templates.fields;

const ModalMassEdit = ({ listing, modalRef }) => {
  const handleClickSecondary = () => {
    modalRef.current.close();
  };

  const handleSubmit = () => {
    modalRef.current.close();
  };

  return (
    <Modal
      ref={modalRef}
      title='Edição em Massa'
      btnPrimaryLabel={`Atualizar ${listing.query.data?.subscriptions.length} registros(s)`}
      btnPrimaryProps={{ form: 'formMassEdit', type: 'submit' }}
      btnSecondaryLabel='Cancelar'
      btnSecondaryClick={handleClickSecondary}
      scrollMode='page'
    >
      <Form
        initialValues={{
          paymentMethod: '',
        }}
        onSubmit={handleSubmit}
        id='formMassEdit'
      >
        <InputField
          name='paymentMethod'
          label='Método de pagamento'
          placeholder=''
          helperText='Método de pagamento principal da assinatura. Alterações nesta configuração serão aplicadas apenas na geração de novas faturas'
          maxMenuHeight={150}
          select
        >
          {paymentMethods.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Form>
    </Modal>
  );
};

export default ModalMassEdit;
